<template>
  <v-dialog @keydown.esc="open=false" v-model="open" persistent max-width="600px">
    <v-card>
      <div class="d-flex justify-end">
        <v-btn
          fab
          color="transparent"
          depressed
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-title class="pt-0 pb-4 title">
        {{ dialogType === 'add'
          ? $t('income.billing.generateInvoicePanel.conceptDialog.titleAdd')
          : $t('income.billing.generateInvoicePanel.conceptDialog.titleEdit')
        }}
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col class="col-6">
            <v-text-field
              rounded
              outlined
              dense
              type="number"
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              v-model.lazy="$v.conceptForm.quantity.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.quantity')"
              @input="$v.conceptForm.quantity.$touch()"
              @blur="$v.conceptForm.quantity.$touch()"
              :error-messages="quantityErrors"
              required
            />
          </v-col>
          <v-col class="col-6">
            <v-select
              rounded
              outlined
              dense
              item-text="name"
              item-value="_id"
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              :items="units"
              v-model.lazy="$v.conceptForm.unit.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.unit')"
              @input="$v.conceptForm.unit.$touch()"
              @blur="$v.conceptForm.unit.$touch()"
              :error-messages="unitErrors"
              required
            />
          </v-col>
          <v-col class="col-6">
            <v-text-field
              rounded
              outlined
              dense
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              v-model.lazy="$v.conceptForm.productOrService.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.productOrService')"
              @input="$v.conceptForm.productOrService.$touch()"
              @blur="$v.conceptForm.productOrService.$touch()"
              :error-messages="productOrServiceErrors"
              required
            />
            <!-- // Todo: get list of products from api service -->
            <!-- <v-select
              rounded
              outlined
              dense
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              item-text="descripcion"
              item-value="clave"
              :items="PRODUCTS_SERVICES_CATALOG"
              v-model.lazy="$v.conceptForm.productOrService.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.productOrService')"
              @input="$v.conceptForm.productOrService.$touch()"
              @blur="$v.conceptForm.productOrService.$touch()"
              :error-messages="productOrServiceErrors"
              required
            >
            <template v-slot:selection="data">
              {{ data.item.clave }} - {{ data.item.descripcion }}
            </template>
            <template v-slot:item="data">
              {{ data.item.clave }} - {{ data.item.descripcion }}
            </template>
            </v-select> -->
          </v-col>
          <v-col class="col-6">
            <v-text-field
              rounded
              outlined
              dense
              v-model.lazy="$v.conceptForm.description.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.description')"
              @input="$v.conceptForm.description.$touch()"
              @blur="$v.conceptForm.description.$touch()"
              :error-messages="descriptionErrors"
              required
            />
          </v-col>
          <v-col class="col-6">
            <v-text-field
              rounded
              outlined
              dense
              type="number"
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              v-model.lazy="$v.conceptForm.unitImport.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.unitImport')"
              @input="$v.conceptForm.unitImport.$touch()"
              @blur="$v.conceptForm.unitImport.$touch()"
              :error-messages="unitImportErrors"
              required
            />
          </v-col>
          <v-col class="col-3">
            <v-checkbox
              dense
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              v-model.lazy="$v.conceptForm.includesTax.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.includesTax')"
              @input="$v.conceptForm.includesTax.$touch()"
              @blur="$v.conceptForm.includesTax.$touch()"
              @change="handleIncludesTaxChange"
              class="mt-0 pt-0"
            />
          </v-col>
          <v-col class="col-3">
            <v-checkbox
              dense
              :readonly="isInvoiceType"
              :disabled="isInvoiceType"
              v-model.lazy="$v.conceptForm.addTax.$model"
              :label="$t('income.billing.generateInvoicePanel.conceptDialog.addTax')"
              @input="$v.conceptForm.addTax.$touch()"
              @blur="$v.conceptForm.addTax.$touch()"
              @change="handleAddTaxChange"
              class="mt-0 pt-0"
            />
          </v-col>
          <v-col class="col-12">
            <div class="d-flex justify-end">
              <table class="totalBox">
                <tbody>
                  <tr>
                    <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.conceptDialog.subtotal') }}</td>
                    <td class="text-right">{{ formatCurrency(subtotal) }}</td>
                  </tr>
                  <tr>
                    <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.conceptDialog.taxAmount') }}</td>
                    <td class="text-right">
                      <div>{{ formatCurrency(taxAmount) }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.conceptDialog.total') }}</td>
                    <td>
                      <div class="text-right">{{ formatCurrency(total) }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>

        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <Button size="regular" type="outlined" @click="closeDialog()" class="mr-2">
          {{ $t('income.billing.generateInvoicePanel.conceptDialog.buttonClose') }}
        </Button>
        <Button v-if="dialogType === 'add'" size="regular" @click="addConcept()">
          {{ $t('income.billing.generateInvoicePanel.conceptDialog.buttonAdd') }}
        </Button>
        <Button v-else size="regular" @click="editConcept(conceptForm.index)">
          {{ $t('income.billing.generateInvoicePanel.conceptDialog.buttonEdit')}}
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, decimal } from 'vuelidate/lib/validators'

import Button from '@/components/elements/Button'
import formatCurrency from '@/utils/formatCurrency'

const DEFAULT_CONCEPT_FORM_VALUES = {
  quantity: '',
  unit: '',
  productOrService: '',
  description: '',
  unitImport: 0,
  subtotal: 0,
  hasTax: false,
  includesTax: false,
  addTax: false,
  taxAmount: 0,
  total: 0
}

const BILLING_TYPES = ['invoice', 'otherInvoices']

const DEFAULT_TAX_RATIO = 0.16

// Todo: get list of products from api service
// const PRODUCTS_SERVICES_CATALOG = [
//   { clave: '90101501', descripcion: 'Restaurantes' },
//   { clave: '90101232', descripcion: 'Servicio meseros' },
//   { clave: '90101223', descripcion: 'Bar' },
//   { clave: '90101334', descripcion: 'Servicio a domicilio' },
//   { clave: '90101355', descripcion: 'Renta' },
//   { clave: '90101506', descripcion: 'Catering' },
//   { clave: '90101507', descripcion: 'Comidas' }
// ]

const positive = (val) => Number(val) > 0

export default {
  name: 'AddInvoiceConceptDialog',
  props: {
    concepts: {
      type: Array,
      default: function () { return [] }
    }
  },
  components: { Button },
  mixins: [validationMixin],
  validations: {
    conceptForm: {
      quantity: { required, decimal, positive },
      unit: { required },
      productOrService: { required },
      description: { required },
      unitImport: { required, decimal, positive },
      hasTax: {},
      includesTax: {},
      addTax: {}
    }
  },
  data () {
    return {
      open: false,
      conceptForm: { ...DEFAULT_CONCEPT_FORM_VALUES },
      dialogType: 'add',
      billingType: BILLING_TYPES[0]
      // Todo: get list of products from api service
      // PRODUCTS_SERVICES_CATALOG
    }
  },
  watch: {
    open: function (val) {
      if (!val) {
        this.resetConceptForm()
      }
    }
  },
  computed: {
    quantityErrors () {
      const errors = []
      if (!this.$v.conceptForm.quantity.$dirty) return errors
      !this.$v.conceptForm.quantity.positive && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.positive'))
      !this.$v.conceptForm.quantity.decimal && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.number'))
      !this.$v.conceptForm.quantity.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.req'))
      return errors
    },
    unitErrors () {
      const errors = []
      if (!this.$v.conceptForm.unit.$dirty) return errors
      !this.$v.conceptForm.unit.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.req'))
      return errors
    },
    productOrServiceErrors () {
      const errors = []
      if (!this.$v.conceptForm.productOrService.$dirty) return errors
      !this.$v.conceptForm.productOrService.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.req'))
      return errors
    },
    descriptionErrors () {
      const errors = []
      if (!this.$v.conceptForm.description.$dirty) return errors
      !this.$v.conceptForm.description.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.req'))
      return errors
    },
    unitImportErrors () {
      const errors = []
      if (!this.$v.conceptForm.unitImport.$dirty) return errors
      !this.$v.conceptForm.unitImport.positive && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.positive'))
      !this.$v.conceptForm.unitImport.decimal && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.number'))
      !this.$v.conceptForm.unitImport.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.conceptDialog.errors.req'))
      return errors
    },
    units () {
      return this.$store.state.login.units.data
    },
    subtotal () {
      let total = 0
      const taxRatio = this.conceptForm.hasTax ? DEFAULT_TAX_RATIO : 0
      if (this.conceptForm.quantity && this.conceptForm.unitImport) {
        total = this.conceptForm.quantity * this.conceptForm.unitImport

        if (this.conceptForm.includesTax) {
          total /= (1 + taxRatio)
        }
      }
      return total.toFixed(2)
    },
    taxAmount () {
      let total = 0
      const taxRatio = this.conceptForm.hasTax ? DEFAULT_TAX_RATIO : 0
      if (this.conceptForm.quantity && this.conceptForm.unitImport) {
        total = this.conceptForm.quantity * this.conceptForm.unitImport * taxRatio

        if (this.conceptForm.includesTax) {
          total /= (1 + taxRatio)
        }
      }
      return total.toFixed(2)
    },
    total () {
      let total = 0
      total = Number(this.subtotal) + Number(this.taxAmount)
      return total.toFixed(2)
    },
    isInvoiceType () {
      return this.billingType === BILLING_TYPES[0]
    }
  },
  methods: {
    openDialog (concept, billingType) {
      this.billingType = billingType

      if (concept) {
        this.dialogType = 'edit'
        this.conceptForm = { ...concept }
      } else {
        this.dialogType = 'add'
      }
      this.open = true
    },
    closeDialog () {
      this.open = false
    },
    addConcept () {
      this.$v.conceptForm.$touch()

      if (!this.$v.conceptForm.$invalid) {
        // const { quantity, unit, productOrService, description, unitImport } = this.conceptForm
        this.concepts.push({
          // quantity,
          // unit,
          // productOrService,
          // description,
          // unitImport,
          ...this.conceptForm,
          subtotal: this.subtotal,
          taxAmount: this.taxAmount,
          total: this.total
        })
        this.closeDialog()
      }
    },
    editConcept (index) {
      this.$v.conceptForm.$touch()

      if (!this.$v.conceptForm.$invalid) {
        // const { quantity, unit, productOrService, description, unitImport } = this.conceptForm

        const updatedConcepts = [ ...this.concepts ]
        updatedConcepts[index] = {
          // quantity,
          // unit,
          // productOrService,
          // description,
          // unitImport,
          ...this.conceptForm,
          subtotal: this.subtotal,
          taxAmount: this.taxAmount,
          total: this.total
        }
        this.$emit('updateConcepts', updatedConcepts)
        this.closeDialog()
      }
    },
    resetConceptForm () {
      this.conceptForm = { ...DEFAULT_CONCEPT_FORM_VALUES }
      this.$v.conceptForm.$reset()
    },
    formatCurrency,
    handleIncludesTaxChange (val) {
      this.conceptForm.hasTax = val
      if (val) {
        this.conceptForm.addTax = !val
      }
    },
    handleAddTaxChange (val) {
      this.conceptForm.hasTax = val
      if (val) {
        this.conceptForm.includesTax = !val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-weight: 500;
    font-size: 22px;
    color: #01D28E;
  }

  .labelWhiteBg {
    & ::v-deep label {
      padding-right: 4px;
      background-color: #fff;
    }
  }

  .totalBox {
    padding: 8px 16px;
    border: 1px solid #ACABAB;
    border-radius: 13px;
  }
</style>
